export enum StatusDocumentEnum {
  EMITIDO = 'EMITIDO',
  PROCESADO = 'PROCESADO',
  PENDING = 'PENDIENTE',
  TRANSIT = 'EN TRANSITO'
}
